var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-page"},[_c('div',{staticClass:"container"},[_c('ProfileInfo'),_c('ProfileTeamToolbar',{attrs:{"loaded":_vm.loaded}}),_c('TeamView',{on:{"loaded":function($event){_vm.loaded = true}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }